<style lang="less">
  @import '../../assets/css/less/vars.less';

  .js-video {
    width: 100%;
    height: 0;
    padding-top: 0;
    padding-bottom: 56.25%;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;

    iframe {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }
</style>

<template>
  <div :class="['video-wrapper', 'js-video']" :style="getStyles">
    <vimeo-player ref="player" :video-id="videoID" @ready="onReady" :player-width="getWidth"></vimeo-player>
  </div>
</template>

<script>
  export default {
    name: 'video-player',
    data () {
      return {
        options: {},
        playerReady: false,
        styleElement: {},
        fluidStatus: true
      }
    },
    mounted () {
      this.$nextTick(function () {
        window.addEventListener('resize', this.onWidthChange)
      })

      let $self = this
      $self.$bus.$on('VIDEO.PLAYVIDEO', () => {
        if ($self.playerReady) {
          $self.$refs.player.play()
        }
      })
    },
    props: {
      videoID: {
        type: String,
        required: true
      },
      inlineStyle: {
        type: Object,
        default: null
      },
      isFluid: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      // Needed to set the video dynamic width on first load
      getWidth () {
        return document.documentElement.clientWidth
      },
      getStyles () {
        if (this.inlineStyle !== undefined) {
          if (this.inlineStyle.width !== undefined || this.inlineStyle.maxWidth !== undefined) {
            this.styleElement = this.util.jsonCopyObject(this.inlineStyle)
          }
          return this.styleElement
        }
        return ''
      }
    },
    watch: {
      fluidStatus () {
        this.fluidStatus = this.getFluid()
      }
    },
    methods: {
      onWidthChange () {
        this.$nextTick(function () {
          this.fluidStatus = this.getFluid()
          this.$refs.player.player.element.width = document.documentElement.clientWidth
        })
      },
      getFluid () {
        if (this.isFluid && (this.styleElement.width !== undefined || this.styleElement.maxWidth !== undefined)) {
          return (parseInt(this.styleElement.width) > document.documentElement.clientWidth || parseInt(this.styleElement.maxWidth) > document.documentElement.clientWidth)
        }
        return false
      },
      onReady () {
        this.$bus.$emit('VIDEO.LOADED')
        this.playerReady = true
        this.$refs.player.player.element.width = document.documentElement.clientWidth
        this.fluidStatus = this.getFluid()
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onWidthChange)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/video-player/index.vue